import styled from 'styled-components';

import FlexContainer from '@components/utils/FlexContainer';

export const VariationLabel = styled.span`
  height: 20px;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  color: ${(p) => p.theme.palette.darkGrey};
  font-size: 16px;
`;

export const Title = styled.span`
  margin-left: 10px;
  font-weight: bold;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 0px;
  }
`;

export const ErrorTitle = styled.span`
  margin-left: 10px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.tomato};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 0px;
  }
`;

export const Container = styled(FlexContainer)`
  flex: 1;
  max-width: 100%;
  margin-top: 16px;
  @media (min-width: 600px) {
    margin-top: 0px;
    padding: 8px;
  } ;
`;
